<template>
<svg xmlns="http://www.w3.org/2000/svg" data-name="Livello 1" viewBox="0 0 24 24" fill="currentColor"><path d="M10.2 18.7H12v2.7h-1.8v-2.7Zm6.7-11.9c0 .9-.1 1.8-.4 2.7-.4.7-1.2 1.5-1.9 2.1l-2.1 1.9c-.3.6-.6 1.2-.6 1.8v.9h-1.3c-.1-.4-.3-1-.3-1.5s.3-1.3.7-1.8c.6-.7 1.3-1.5 2.1-2.1s1.3-1.2 1.8-1.9c.3-.6.4-1.3.4-2.1s-.3-1.6-.9-2.1c-.9-.4-1.9-.7-3-.6L8 4.5h-.7V3.3c1.5-.4 3-.7 4.5-.7 1.3-.1 2.8.1 4 .9.9.9 1.3 2.1 1.2 3.3Z"/></svg>
</template>

